<div class="layout-settings">
  <div class="row g-3">

    <!-- Navbar -->
    <div class="col-12 col-lg-6">
      <lib-gung-accordion [closeOthers]="false">
        <lib-gung-accordion-item id="navbar" [collapsed]="false">
          <ng-template libGungAccordionHeader>
            <span class="accordion-title">Navbar</span>
            <span class="accordion-subtitle">Controls the top navigation shown across the storefront.</span>
            <i class="fal fa-chevron-down accordion-chevron-icon"></i>
          </ng-template>
          <ng-template libGungAccordionBody>

            <div class="body-header">
              <gung-button
                *ngIf="!showingCodeDefaults"
                classes="btn-outline-secondary btn-sm settings-reset-btn"
                label="Reset to defaults"
                [onClick]="resetNavbarToDefaults.bind(this)"
              ></gung-button>
            </div>

            <div *ngIf="showingCodeDefaults" class="settings-defaults-notice">
              <p class="mb-2">Using project code defaults. Save to apply, or click <strong>Customize</strong> to override.</p>
              <gung-button classes="btn-sm btn-outline-primary" label="Customize" [onClick]="customizeNavbar.bind(this)"></gung-button>
            </div>

            <ng-container *ngIf="!showingCodeDefaults">
              <div class="settings-control-group">
                <label class="control-label">Navbar type
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Whether the top navigation menu is built from assortments (category tree) or from flows."></i>
                </label>
                <lib-gung-select-option-input
                  gungTranslate="Navbar type"
                  [labelClass]="['d-none']"
                  [optionsList]="navbarTypeOptions"
                  [(ngModel)]="myCompanyLayout.navbar.type"
                ></lib-gung-select-option-input>
              </div>

              <ng-container *ngIf="myCompanyLayout.navbar.type === 'assortment'">
                <div class="settings-control-group">
                  <label class="control-label">Menu level
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Controls the assortment menu depth. 0 = flat, 1–4 = levels deep, auto = determined automatically."></i>
                  </label>
                  <lib-gung-select-option-input
                    gungTranslate="Menu level"
                    [labelClass]="['d-none']"
                    [optionsList]="assortmentMenuLevelOptions"
                    [(ngModel)]="assortmentMenuLevelStr"
                  ></lib-gung-select-option-input>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">Remove top level</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Removes the user's top-level assortment node from the menu, showing its children directly."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="removeUserAssortmentTopLevel" [(ngModel)]="myCompanyLayout.navbar.removeUserAssortmentTopLevel" />
                  </div>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">Force not show flows on top</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="When assortment-based and multiple flows exist, prevents flows from being shown at the top of the navbar."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="forceToNotShowFlowsOnTop" [(ngModel)]="myCompanyLayout.navbar.forceToNotShowFlowsOnTop" />
                  </div>
                </div>
              </ng-container>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Hide my customers</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Hides the 'My Customers' section from the navbar."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="hideMyCustomers" [(ngModel)]="myCompanyLayout.navbar.hideMyCustomers" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Hide favorites</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Hides the favorites icon/link from the navbar."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="hideFavorites" [(ngModel)]="myCompanyLayout.navbar.hideFavorites" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Hide cart</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Hides the shopping cart icon from the navbar."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="hideCart" [(ngModel)]="myCompanyLayout.navbar.hideCart" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Hide selected customer</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Hides the currently selected customer indicator from the navbar."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="hideSelectedCustomer" [(ngModel)]="myCompanyLayout.navbar.hideSelectedCustomer" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Show navbar search</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Shows a search input field directly in the navbar."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="showNavbarSearch" [(ngModel)]="myCompanyLayout.navbar.showNavbarSearch" />
                </div>
              </div>
            </ng-container>

          </ng-template>
        </lib-gung-accordion-item>
      </lib-gung-accordion>
    </div>

    <!-- Checkout -->
    <div class="col-12 col-lg-6">
      <lib-gung-accordion [closeOthers]="false">
        <lib-gung-accordion-item id="checkout" [collapsed]="false">
          <ng-template libGungAccordionHeader>
            <span class="accordion-title">Checkout</span>
            <span class="accordion-subtitle">How the checkout flow behaves for this storefront.</span>
            <i class="fal fa-chevron-down accordion-chevron-icon"></i>
          </ng-template>
          <ng-template libGungAccordionBody>

            <div class="body-header">
              <gung-button
                *ngIf="!showingCheckoutCodeDefaults"
                classes="btn-outline-secondary btn-sm settings-reset-btn"
                label="Reset to defaults"
                [onClick]="resetCheckoutToDefaults.bind(this)"
              ></gung-button>
            </div>

            <div *ngIf="showingCheckoutCodeDefaults" class="settings-defaults-notice">
              <p class="mb-2">Using project code defaults. Save to apply, or click <strong>Customize</strong> to override.</p>
              <gung-button classes="btn-sm btn-outline-primary" label="Customize" [onClick]="customizeCheckout.bind(this)"></gung-button>
            </div>

            <ng-container *ngIf="!showingCheckoutCodeDefaults">
              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Side buttons</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Displays the checkout action buttons on the side of the page instead of at the bottom."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="sideButtons" [(ngModel)]="myCompanyLayout.checkout.sideButtons" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Discount codes</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Shows a discount/welcome code input field during checkout. Requires gung-discount-codes to be activated."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="enableDiscount" [(ngModel)]="myCompanyLayout.checkout.enableDiscount" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Enable offers</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Allows users to create quotations/offers instead of placing a direct order."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="enableOffers" [(ngModel)]="myCompanyLayout.checkout.enableOffers" />
                </div>
              </div>

              <div class="settings-toggle-row">
                <div class="toggle-info">
                  <span class="toggle-label">Hide create quotation</span>
                  <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Hides the 'Create quotation' button in checkout even when offers are enabled."></i>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="hideCreateQuotation" [(ngModel)]="myCompanyLayout.checkout.hideCreateQuotation" />
                </div>
              </div>

              <ng-container *ngIf="checkoutConfigService.checkoutOnCartList">
                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">Enable global delivery date</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Shows a single global delivery date picker that applies to all order rows in the cart list."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="enableGlobalDeliveryDate" [(ngModel)]="myCompanyLayout.checkout.enableGlobalDeliveryDate" />
                  </div>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">User can change delivery dates</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Allows users to change the delivery date on individual order rows in the cart list."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="userCanChangeDeliveryDates" [(ngModel)]="myCompanyLayout.checkout.userCanChangeDeliveryDates" />
                  </div>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">Sales can edit price</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Allows sales/admin users to edit the unit price on order rows in the cart list."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="enableSalesEditPrice" [(ngModel)]="myCompanyLayout.checkout.enableSalesEditPrice" />
                  </div>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">Sales can edit discount</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Allows sales/admin users to edit the discount percentage on order rows in the cart list."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="enableSalesEditDiscount" [(ngModel)]="myCompanyLayout.checkout.enableSalesEditDiscount" />
                  </div>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">User can add description</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Allows users to add a description/comment to individual order rows in the cart list."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="userCanAddDescription" [(ngModel)]="myCompanyLayout.checkout.userCanAddDescription" />
                  </div>
                </div>

                <div class="settings-toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-label">Enable copy row</span>
                    <i class="fal fa-question-circle info-icon ms-1" ngbTooltip="Shows a button to duplicate an order row in the cart list."></i>
                  </div>
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="enableCopyRow" [(ngModel)]="myCompanyLayout.checkout.enableCopyRow" />
                  </div>
                </div>
              </ng-container>
            </ng-container>

          </ng-template>
        </lib-gung-accordion-item>
      </lib-gung-accordion>
    </div>

    <!-- Page Container -->
    <div class="col-12">
      <lib-gung-accordion [closeOthers]="false">
        <lib-gung-accordion-item id="page-container" [collapsed]="false">
          <ng-template libGungAccordionHeader>
            <span class="accordion-title">Page Container</span>
            <span class="accordion-subtitle">Controls the maximum content width and layout constraints.</span>
            <i class="fal fa-chevron-down accordion-chevron-icon"></i>
          </ng-template>
          <ng-template libGungAccordionBody>

            <div class="settings-control-group">
              <label class="control-label">Max Width</label>
              <div class="input-group input-group-sm max-width-input">
                <input type="number" class="form-control" [(ngModel)]="myCompanyLayout.maxWidth" min="0" step="1" placeholder="No limit" />
                <div class="input-group-append">
                  <span class="input-group-text">px</span>
                </div>
              </div>
            </div>

            <div class="settings-control-group mb-0">
              <label class="control-label">
                Excluded URLs
                <span class="control-hint">Max width will not be applied to these paths.</span>
              </label>
              <div class="input-group input-group-sm mb-2 url-input-group">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="newUrl"
                  (keyup.enter)="addUrl()"
                  placeholder="Enter a URL path..."
                />
                <div class="input-group-append">
                  <gung-button classes="btn-primary btn-sm" label="Add" [onClick]="addUrl.bind(this)"></gung-button>
                </div>
              </div>
              <div class="d-flex flex-wrap gap-2" *ngIf="myCompanyLayout.excludedUrls?.length > 0">
                <span
                  *ngFor="let url of myCompanyLayout.excludedUrls; let i = index"
                  class="url-badge d-inline-flex align-items-center gap-1"
                >
                  {{ url }}
                  <gung-button classes="btn-link p-0 url-remove-btn" icon="fas fa-times" [onClick]="removeUrl.bind(this, i)"></gung-button>
                </span>
              </div>
            </div>

          </ng-template>
        </lib-gung-accordion-item>
      </lib-gung-accordion>
    </div>

  </div>
</div>
